import { apiClient } from '@isocel/front-common';

import { BaseModel } from './types';

export const fetchTransporters = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/transporters`);
    data.sort((a: BaseModel, b: BaseModel) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    return data;
};
